/* ============================================================
   PURE BIRKDALE — theme global JS
   Ajax cart drawer, mega menu, mobile nav, accordions, reveal.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  /* ---------- header shadow on scroll ---------- */
  var header = qs('[data-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10 ? 'var(--shadow-sm)' : '';
    }, { passive: true });
  }

  /* ---------- mega menu (hover with close delay, like the prototype) ---------- */
  qsa('[data-mega-item]').forEach(function (item) {
    var closeT;
    item.addEventListener('mouseenter', function () { clearTimeout(closeT); item.classList.add('open'); });
    item.addEventListener('mouseleave', function () { closeT = setTimeout(function () { item.classList.remove('open'); }, 120); });
  });

  /* ---------- mobile nav ---------- */
  var mnav = qs('[data-mobile-nav]');
  var mnavOverlay = qs('[data-mobile-nav-overlay]');
  function setMobileNav(open) {
    if (!mnav) return;
    mnav.classList.toggle('show', open);
    if (mnavOverlay) mnavOverlay.classList.toggle('show', open);
  }
  qsa('[data-mobile-nav-open]').forEach(function (b) { b.addEventListener('click', function () { setMobileNav(true); }); });
  qsa('[data-mobile-nav-close]').forEach(function (b) { b.addEventListener('click', function () { setMobileNav(false); }); });
  if (mnavOverlay) mnavOverlay.addEventListener('click', function () { setMobileNav(false); });
  qsa('[data-mnav-toggle]').forEach(function (head) {
    head.addEventListener('click', function () { head.closest('[data-mnav-item]').classList.toggle('open'); });
  });

  /* ---------- accordions (PDP + FAQs) ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.acc-head');
    if (head) head.closest('.acc-item').classList.toggle('open');
  });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -40px' });
    qsa('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    qsa('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ============================================================
     AJAX CART
     All mutations POST to the cart API then re-render the drawer
     section via the Section Rendering API so Liquid stays the
     single source of truth for drawer markup.
     ============================================================ */
  var Cart = {
    open: function () {
      var d = qs('[data-cart-drawer]'), o = qs('[data-cart-overlay]');
      if (d) d.classList.add('show');
      if (o) o.classList.add('show');
      document.documentElement.style.overflow = 'hidden';
    },
    close: function () {
      var d = qs('[data-cart-drawer]'), o = qs('[data-cart-overlay]');
      if (d) d.classList.remove('show');
      if (o) o.classList.remove('show');
      document.documentElement.style.overflow = '';
    },
    refresh: function (openAfter) {
      return fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections['cart-drawer'];
          if (!html) return;
          var tpl = document.createElement('div');
          tpl.innerHTML = html;
          var freshDrawer = tpl.querySelector('[data-cart-drawer]');
          var curDrawer = qs('[data-cart-drawer]');
          var wasOpen = curDrawer && curDrawer.classList.contains('show');
          if (freshDrawer && curDrawer) {
            curDrawer.innerHTML = freshDrawer.innerHTML;
            Cart.bindDrawer();
          }
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            qsa('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.hidden = cart.item_count === 0;
            });
            if (openAfter || wasOpen) Cart.open();
          });
        });
    },
    add: function (variantId, qty, sellingPlan, properties) {
      var body = { id: Number(variantId), quantity: qty || 1 };
      if (sellingPlan) body.selling_plan = Number(sellingPlan);
      if (properties) body.properties = properties;
      return fetch(window.PBTheme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return Cart.refresh(true);
      });
    },
    changeLine: function (line, qty) {
      return fetch(window.PBTheme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
      }).then(function () { return Cart.refresh(); });
    },
    bindDrawer: function () {
      qsa('[data-cart-close]').forEach(function (b) { b.addEventListener('click', Cart.close); });
      qsa('[data-qty-change]').forEach(function (b) {
        b.addEventListener('click', function () { Cart.changeLine(b.dataset.line, b.dataset.qty); });
      });
    }
  };
  window.PBCart = Cart;

  qsa('[data-cart-open]').forEach(function (b) { b.addEventListener('click', Cart.open); });
  var overlay = qs('[data-cart-overlay]');
  if (overlay) overlay.addEventListener('click', Cart.close);
  Cart.bindDrawer();

  /* quick add from product cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    btn.disabled = true;
    Cart.add(btn.dataset.variantId, 1).catch(function (err) {
      alert((err && err.description) || 'Could not add to bag.');
    }).finally(function () { btn.disabled = false; });
  });

  /* Phorest booking handoff — every [data-book-now] opens the live booking site */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-book-now]');
    if (!el) return;
    e.preventDefault();
    window.open(window.PBTheme.phorestBooking, '_blank', 'noopener');
  });
})();

/* ============================================================
   Predictive search — live product suggestions under the header
   search inputs (desktop pill + mobile row).
   ============================================================ */
(function () {
  'use strict';
  var forms = document.querySelectorAll('.search-mini, .search-mobile');
  Array.prototype.forEach.call(forms, function (form) {
    var input = form.querySelector('input[type="search"]');
    if (!input) return;
    var box = document.createElement('div');
    box.className = 'search-suggest';
    box.hidden = true;
    form.appendChild(box);
    var timer = null, lastQ = '';
    function close() { box.hidden = true; box.innerHTML = ''; }
    function render(products, q) {
      if (!products.length) { close(); return; }
      box.innerHTML = products.map(function (p) {
        var src = (p.featured_image && p.featured_image.url) || p.image || '';
        var img = src ? '<img src="' + src + '" alt="" loading="lazy">' : '<span class="ss-noimg"></span>';
        var price = p.price ? '£' + String(p.price).replace(/^£/, '') : '';
        return '<a class="ss-item" href="' + p.url + '">' + img +
          '<span class="ss-body"><b>' + p.title + '</b><small>' + price + '</small></span></a>';
      }).join('') + '<a class="ss-all" href="/search?q=' + encodeURIComponent(q) + '">See all results</a>';
      box.hidden = false;
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        lastQ = q;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (q !== lastQ) return;
            var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
            render(prods, q);
          })
          .catch(close);
      }, 220);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  });
})();
